export const backendHosts = {
  development: {
    apiBaseUrl: 'http://localhost:3000/api',
    wsBaseUrl: 'ws://localhost:3000/ws',
    backendLabel: 'http://localhost:3000'
  },
  production: {
    apiBaseUrl: 'https://www.daniiplace.at/api',
    wsBaseUrl: 'wss://www.daniiplace.at/ws',
    backendLabel: 'https://www.daniiplace.at'
  }
} as const;

const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

export const appEnvironment = isLocalhost
  ? backendHosts.development
  : backendHosts.production;